import { useState } from "react";
import {
  handleDeletePost,
  handleLikePost,
  handleRemoveUser,
  handleSaveComment,
  handleSendReport,
  handleUnfollow,
  handleUnlikePost,
} from "../api/timelineAPIs";
import useGetPostComments from "../api/useGetPostComments";

const useTimeline = ({ user, token, secondParty, id, likes, refetch }) => {
  const [showCommentForm, setShowCommentForm] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [replyContent, setReplyContent] = useState("");
  const [showCommentList, setShowCommentList] = useState(false);
  const [like, setLike] = useState(false);

  const { comments, refetchComments } = useGetPostComments(
    secondParty,
    id,
    token
  );

  const hasLikes = likes?.some((content) => content.isLiked);
  const likeCount = likes?.filter((el) => el.isLiked).length ?? 0;
  const isAuthor = user.email === secondParty;

  const handleCloseCommenter = () => {
    setShowCommentForm(false);
    refetchComments();
  };

  const toggleCommentForm = () => {
    setShowCommentForm((prev) => !prev);
    setShowCommentList(false);
  };

  const toggleCommentList = () => {
    setShowCommentList((prev) => !prev);
  };

  const onLike = () => {
    handleLikePost(secondParty, id, user, setLike, token, refetch);
  };

  const onUnlike = () => {
    handleUnlikePost(secondParty, id, user, setLike, token, refetch);
  };

  const onDelete = () => {
    handleDeletePost(user, id, token, refetch);
  };

  const onUnfollow = () => {
    handleUnfollow(user, secondParty, token);
  };

  const onBlock = () => {
    handleRemoveUser(user, secondParty, token);
  };

  const onReport = () => {
    handleSendReport(id, user, secondParty, token);
  };

  const onComment = () => {
    handleSaveComment(secondParty, id, replyContent, user, token);
  };

  return {
    showCommentForm,
    showPopover,
    setShowPopover,
    showEdit,
    setShowEdit,
    replyContent,
    setReplyContent,
    showCommentList,
    like,
    comments,
    hasLikes,
    likeCount,
    isAuthor,
    handleCloseCommenter,
    toggleCommentForm,
    toggleCommentList,
    onLike,
    onUnlike,
    onDelete,
    onUnfollow,
    onBlock,
    onReport,
    onComment,
  };
};

export default useTimeline;
